<template>
  <TableLayout :permissions="['business:activity:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="资讯标题" prop="name">
        <el-input v-model="searchForm.name" placeholder="请输入资讯标题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="发布人" prop="realName">
        <el-input v-model="searchForm.realName" placeholder="请输入发布人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="用户类型" prop="userType">
        <el-select
          v-model="searchForm.userType"
          placeholder="请选择用户类型"
        >
        <!-- 0系统管理员 1机构管理员 2创作中心管理员 -->
          <el-option
            v-for="item in userType"
            :key="item.id"
            :value="item.id"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:activity:create', 'business:activity:delete']">
        <li><el-button type="primary" @click="$refs.operaInformationWindow.open('新建')" icon="el-icon-plus" v-permissions="['business:activity:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:activity:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="imgurlfull" label="资讯主图" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-image :scr="row.imgurlfull" :preview-src-list="[row.imgurlfull]"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="资讯标题" align="center" min-width="100px">
          <template slot-scope="{row}">
            <el-button type="text" @click="shopDetail(row)">{{ row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="lablesName" label="资讯分类" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="realName" label="发布用户" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="name" label="用户类型" align="center" min-width="100px">
          <template slot-scope="{row}">
            {{ userTypeToStr(row.userType) }}
          </template>
        </el-table-column>
        <el-table-column prop="looknum" label="浏览数" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="zanCount" label="点赞数" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="commentCount" label="评论数" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="collectCount" label="收藏数" align="center" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="发布时间" align="center" min-width="140px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:activity:update', 'business:activity:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaInformationWindow.open('编辑', row)" icon="el-icon-edit" v-permissions="['business:activity:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:activity:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaInformationWindow ref="operaInformationWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaInformationWindow from '@/components/business/OperaInformationWindow'
export default {
  name: 'Information',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaInformationWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        name: '',
        realName: '',
        userType: '',
        type: 3 //类型0商家活动 1平台活动 2探店 3资讯
      },
      // 0系统管理员 1机构管理员 2创作中心管理员
      userType: [
        { label: '平台', id: 0 },
        { label: '机构', id: 1 },
        { label: '创作者', id: 2 }
      ]
    }
  },
  created () {
    this.config({
      module: '资讯信息表',
      api: '/business/activity',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    userTypeToStr(type) {
      const temp = this.userType.find(item => item.id = type)
      return temp ? temp.label : '-'
    },
    shopDetail(row) {
      
    }
  },
}
</script>
